module.exports = __webpack_public_path__ + "images/Fear_Index-cbef86.png";